import * as S from "../Style/Page/Car.style.js";
const LeftImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/Car.f8d54def2e59a69fd547.png`;
const HatPageTopLine = (props) => {
  return (
    <S.PageTopLine>
      <div className="page-top-line-left">
        <img src={LeftImg} alt="" />
      </div>
      <div className="page-top-line-title">
        {" "}
        <div class="kor">{props.titleko}</div>
        <div class="eng">{props.titleeng}</div>
      </div>
      <div className="page-top-line-right"></div>
    </S.PageTopLine>
  );
};

export default HatPageTopLine;
